var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5 12.5C23.5 18.8513 18.3513 24 12 24C5.64873 24 0.5 18.8513 0.5 12.5C0.5 6.14873 5.64873 1 12 1C18.3513 1 23.5 6.14873 23.5 12.5ZM13.0001 18.639C13.0001 19.1913 12.5524 19.6391 12.0001 19.6391C11.4478 19.6391 11 19.1913 11 18.639C11 18.0867 11.4478 17.6389 12.0001 17.6389C12.5524 17.6389 13.0001 18.0867 13.0001 18.639ZM13.1833 11.1904C11.8793 11.6253 10.9997 12.8461 10.9997 14.2207V16.6396H12.9997V14.2207C12.9997 13.7069 13.3287 13.2504 13.8161 13.0879C15.1203 12.6531 15.9997 11.4323 15.9997 10.0576V9.54491C15.9997 7.38782 14.2515 5.63879 12.0944 5.63866H11.9997C9.79054 5.63875 7.99976 7.42953 7.99967 9.63866H9.99967C9.99976 8.53416 10.8952 7.63875 11.9997 7.63866H12.0944C13.1468 7.63879 13.9997 8.49245 13.9997 9.54491V10.0576C13.9997 10.5714 13.6707 11.0279 13.1833 11.1904Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.90ce36ee3d89f4f7736e185b52554cf7.svg";
export { ForwardRef as ReactComponent };